/* eslint-disable @typescript-eslint/no-floating-promises */
import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translation files directly
import enTranslation from '@/locales/en/translation.json'
import enErrors from '@/locales/en/errors.json'
import zhTranslation from '@/locales/zh/translation.json'
import zhErrors from '@/locales/zh/errors.json'

const resources = {
  en: {
    translation: enTranslation,
    errors: enErrors
  },
  zh: {
    translation: zhTranslation,
    errors: zhErrors
  }
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: true,
    interpolation: {
      escapeValue: false
    },
    supportedLngs: ['en', 'zh'],
    nonExplicitSupportedLngs: true
  })

export default i18n
